import React, { useEffect, useState } from "react";
import "./Navbar.scss";
import "../Button/button.scss";
import {
    setHeaderLoadType
} from "../../slices/vehicleSlice";
import {useSelector} from "react-redux";

const Navbar = ({ leftChildren, rightChildren, isTop, isMobile }) => {
    const [isSticky, setIsSticky] = useState(false);
    const headerLoadType = useSelector(setHeaderLoadType);

    useEffect(() => {
        const handleScroll = () => {
           !isMobile && setIsSticky(headerLoadType ? window.scrollY > 185 : window.scrollY > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const pathnameIncludesFeatures = window.location.pathname.includes("features");

    const appNavbarClasses = `appNavbar ${!isTop ? "appNavbar-hidden" : ""} ${
        isSticky ? "appNavbar-sticky" : ""
    } ${pathnameIncludesFeatures ? "appNavbar-sticky-features" : ""}`;

    return (
        <div className={'navbar-main'}>
            { headerLoadType != null ? (
                <div>
                    <div className={"navbar-intro"}>
                        <div className={'navbar-intro-container'}>
                            <h1>Compare Cars Side-by-Side</h1>
                            <span>Compare up to 4 vehicles at once, whether it’s different trims or competing models. See which one is the best fit for your needs.</span>
                        </div>
                    </div>
                    <div className={appNavbarClasses}>
                        <div className={"navbarContainer"}>
                            {leftChildren}

                            <div className={"navbar-right"}>{rightChildren}</div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={'navbar-default'}>
                    <div className={'navbar-default-container'}>
                        <div className={appNavbarClasses}>
                            <div className={"navbarContainer"}>
                                {leftChildren}

                                <div className={"navbar-right"}>{rightChildren}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Navbar;
